module.exports = __webpack_public_path__ + "img/60c48b6fafa071.73308409.9ff38158.png";